import { LevelType } from '@com-delta-idp/mnx-skymiles-shared';
import { Status } from '../../models/aem/overview.interface';

export const getLevel = (content: Status, statusLevel: LevelType): string => {
  return (
    content.ariaLabel.level +
    ' ' +
    statusLevel +
    ' ' +
    content.ariaLabel.millionMiler
  );
};

export const getTitle = (miles: string, title: string): string => {
  return `${miles} ${title}`;
};
